import React, { useEffect, useState } from 'react';
import { Navigate, Routes, Route, BrowserRouter as Router } from 'react-router-dom';
import './App.css';

import { Amplify } from 'aws-amplify';
import { AuthState, onAuthUIStateChange } from '@aws-amplify/ui-components';
import { withAuthenticator } from '@aws-amplify/ui-react';

import { ListEc2Query, ListEc2ConfigsQuery } from './lib/api';
import { API } from './lib/fetcher';

import Admin from './layouts/Admin';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

declare const window: any;

Amplify.configure({ ...window.ENV });

type ContextProps = {
  ec2List: ListEc2Query;
  // configResult: QueryResult<ListEc2ConfigsQuery, any>,
  configResultData: ListEc2ConfigsQuery;
};

export const AppContext = React.createContext<Partial<ContextProps>>({});

function App() {
  const [username, setUsername] = useState('nope');

  useEffect(() => {
    onAuthUIStateChange((nextAuthState, authData: any) => {
      setUsername(authData?.username);
      API.updateIsSignedIn(nextAuthState === AuthState.SignedIn);
      API.updateApiKey(window.ENV.aws_appsync_apiKey);
    });

    return onAuthUIStateChange((nextAuthState, authData: any) => {
      setUsername(authData?.username);
      API.updateIsSignedIn(nextAuthState === AuthState.SignedIn);
      API.updateApiKey(window.ENV.aws_appsync_apiKey);
      // componentMounted = false;
    });
  }, []);

  // https://github.com/ramyx/material-dashboard-reactts
  return (
    <QueryClientProvider client={queryClient}>
      <div className="App">
        <Router>
          <Routes>
            <Route
              path="/admin/*"
              element={<Admin username={username} />}
            />
            <Route path="/" element={<Navigate to="/admin/dashboard" />} />
          </Routes>
        </Router>
      </div>
    </QueryClientProvider>
  );
}

export default withAuthenticator(App);
// export default App;
